<div class="banner-for-test-site">
  <div class="flex-grow-1 text-center">
    <div 
      class="banner-container px-4 my-0 py-2 text-white justify-content-around align-items-center eye-of-the-tiger d-inline-block font-weight-bold" 
      *ngIf="displayEnvironmentWarning"
      [ngClass]="bannerColor"
    >
  
      <span class="icon mx-2">
        <i *ngIf="environmentName.toUpperCase() !== 'LOCAL'; else local" class="fa-solid fa-diamond-exclamation" aria-hidden="true"></i>      
      </span>
      <span >{{environmentName | uppercase}} ENVIRONMENT</span>
      <span class="icon mx-2">
        <i *ngIf="environmentName.toUpperCase() !== 'LOCAL'; else local" class="fa-solid fa-diamond-exclamation" aria-hidden="true"></i> 
      </span>
    </div>
  </div>
  
  <ng-template #local>
    <i class="fa-solid fa-fire fa-beat text-warning" aria-hidden="true"></i> 
  </ng-template>

</div>


// WEBPACK FOOTER //
// ./src/app/core/components/test-banner/test-banner.component.html